import { render, staticRenderFns } from "./settingsSite.vue?vue&type=template&id=35275df0&scoped=true&"
import script from "./settingsSite.vue?vue&type=script&lang=js&"
export * from "./settingsSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35275df0",
  null
  
)

export default component.exports